<template>
  <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;" @keyup.esc="closeModal">
    <Trap>

      <div class="modal-dialog modal-dialog-centered modal-md" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-body pt-3" style="max-height: 100%; overflow-y: auto;">
            <div class="lbl mb-2" style="font-size: 20px">
              <strong>Mais Opções</strong>
            </div>
            <button @click="closeModal" class="close">
              <span>&times;</span>
            </button>
            <div class="main-content">
              <div class="row">
                <div class="col-12">
                  <div class="lbl mb-2">
                    Caixa
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 mb-2">
                  <button class="btn btn-green font-weight-bold w-100" :style="bgButton"
                    @click="handleEmit('fecharcaixa')">
                    <span style="font-size:15px;">Fechar Caixa (Alt + F)</span>
                  </button>
                </div>
                <div class="col-12 mb-2">
                  <button class="btn btn-green font-weight-bold w-100" :style="bgButton" @click="handleEmit('sangrar')">
                    <span style="font-size:15px;">Sangrar (Alt + S)</span>
                  </button>
                </div>
                <div class="col-12 mb-2">
                  <button class="btn btn-green font-weight-bold w-100" :style="bgButton"
                    @click="handleEmit('reforcar')">
                    <span style="font-size:15px;">Reforçar (Alt + R)</span>
                  </button>
                </div>
                <div class="col-12 mb-2">
                  <button class="btn btn-green font-weight-bold w-100" :style="bgButton" @click="handleEmit('pendcli')">
                    <span style="font-size:15px;">Pendencias Cliente</span>
                  </button>
                </div>

              </div>
              <div class="row">
                <div class="col-12">
                  <div class="lbl mb-2">
                    Venda
                  </div>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 mb-2">
                  <button class="btn btn-green font-weight-bold w-100" :style="bgButton" @click="handleEmit('excluir')">
                    <span style="font-size:15px;">Excluir Produto (Alt + D)</span>
                  </button>
                </div>
                <div class="col-12 mb-2">
                  <button class="btn btn-green font-weight-bold w-100" :style="bgButton"
                    @click="handleEmit('destaques')">
                    <span style="font-size:15px;">Destaques</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </Trap>
  </div>
</template>

<script>
import Trap from "vue-focus-lock";

export default {
  components: {
    Trap,
  },

  props: {
    params_pdv: {
      type: Object,
      default: () => ({ colors: {} })
    },
    bgButton: null,
  },
  data() {
    return {

    };
  },
  computed: {
  },
  methods: {
    handleEmit(selected) {
      this.$emit('selected', selected)
    },
    closeModal() {
      this.$emit("close");
    }
  },
  created() {
    window.addEventListener("keyup", event => {
      if (event.key === "Escape") this.closeModal();
    });
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.closeModal);
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-modal-opcoes.vue